import styled from "styled-components";
import { BADGE_ASPECT } from "./partner-badge-layout";

const PREVIEW_WIDTH = 260;

const BadgeContainer = styled.div`
  position: relative;
  width: ${PREVIEW_WIDTH}px;
  height: ${PREVIEW_WIDTH * BADGE_ASPECT}px;
`;
const BadgeImg = styled.img`
  display: block;
  width: 100%;
  height: 100%;
`;
const LogoBox = styled.div`
  position: absolute;
`;
const Logo = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

// Preview of the funnel footer badge (Asana 1213410886347834): same layout
// as funnel-app's footer, 260 instead of 200 px wide.
const PartnerBadgePreview = ({ badge, logoSrc }) => {
  const { left, top, width, height } = badge.logoBox;
  return (
    <BadgeContainer data-testid="partner-badge-preview">
      <BadgeImg src={badge.src} alt="A&M Unternehmerberatung Premium-Partner" />
      <LogoBox
        style={{
          left: `${left}%`,
          top: `${top}%`,
          width: `${width}%`,
          height: `${height}%`
        }}
      >
        <Logo src={logoSrc} alt="" />
      </LogoBox>
    </BadgeContainer>
  );
};
export default PartnerBadgePreview;
